<div cdkDropList
     class="item-dropzone parent"
     [style.background-color]="blockColor"
     [class.dragging]="dragStarted$ | async"
     [id]="parentItemId"
     [cdkDropListData]="parentItem()"
     [cdkDropListConnectedTo]="allDropListsIds()"
     (cdkDropListDropped)="onDragDrop($event)">
  <div cdkDrag
       (cdkDragStarted)="setDragStarted(true) "
       (cdkDragEnded)="setDragStarted(false) "
       [id]="item().uId"
       [cdkDragData]="item()">
    <div title="Drag this item with children"
         class="item-drag-handle"
         cdkDragHandle>
      @if (item().keyword) {
        <app-search-query-keyword [keyword]="item().keyword!"
                                  [showDelete]="false"
                                  [filterInput]="item().filter!"
                                  (filterChange)="filterChange($event)"
                                  (deleteKeyword)="deleteItem(item())"
        ></app-search-query-keyword>
      }
    </div>
    <div class="item-drag-preview"
         *cdkDragPreview>
      @if (item().keyword) {
        Move {{ item().keyword!.keyword }}
      } @else {
        Move {{ item().children.length }} child item(s)
      }
    </div>
  </div>
  <div cdkDropList
       class="item-dropzone child"
       [class.empty]="item().children.length === 0"
       [class.dragging]="dragStarted$ | async"
       [id]="item().uId"
       [cdkDropListConnectedTo]="connectedDropListsIds"
       [cdkDropListData]="item()"
       (cdkDropListDropped)="onDragDrop($event)">
    @for (subItem of item().children; track subItem.uId) {
      <app-search-keyword-item [item]="subItem"
                               [parentItem]="item()"
                               [allDropListsIds]="allDropListsIds()"
                               (itemDeleted)="deleteItem($event)"
                               (updated)="updated.emit()"
                               (itemDrop)="onDragDrop($event)">
      </app-search-keyword-item>
      @if (!$last) {
        <app-search-query-operator-toggle
          [operatorInput]="item().operator"
          (operatorChange)="operatorChange($event)">
        </app-search-query-operator-toggle>
      }
    }
  </div>
</div>
